<template>
    <v-container>
        <v-card class="pa-16">
            <v-row>
                <v-col cols="12" md="6">
                    <v-card-title class="text-h5">Progress & Timeline</v-card-title>
                </v-col>
                <v-col align="right" color="primary" cols="12" md="6">
                    <v-btn @click="opendialogAdd" color="#0A7EA5" rounded dark class="mb-2">
                        <span>Add</span>
                        <v-icon small center>add</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field class="widthsizesearch" v-model="search" append-icon="mdi-magnify" label="Search"
                        single-line hide-details outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-end mb-6">
                </v-col>
            </v-row>

            <br />

            <v-card outlined tile class="mt-2">
                <v-data-table dense :search="search" :headers="headers" :items="mDataArray"
                    class="elevation-1   595959">
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon class="mr-3" :style="{
                            backgroundColor: '#E1F5FE',
                            color: '#254E58',
                        }" @click="openeditItem(item)">
                            mdi-pencil
                        </v-icon>
                        <v-icon :style="{
                            backgroundColor: '#FEE2E2',
                            color: '#B91C1C'
                        }" @click="opendeleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                    <!-- STATUS -->
                    <template v-slot:[`item.status`]="{ item }">
                        <div class="font-weight-medium">
                            <v-icon v-if="item.icon" :color="item.icon_color || '#000'" small class="mr-2">
                                {{ item.icon }}
                            </v-icon>
                            {{ item.status }}
                        </div>
                    </template>

                </v-data-table>
            </v-card>
        </v-card>
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAddData" max-width="500px">
            <v-card>
                <br />
                <v-card-title class="text-h6">Internal Progress Status Confing</v-card-title>
                <v-card-text>
                    <v-container>

                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <h3>Status</h3>
                                <v-autocomplete ref="Code" v-model="dataItem.timeline_status_id"
                                    :items="timeLineStatusList" item-value="id" item-text="status" outlined dense
                                    :disabled="modeActions === 'Edit'"
                                    :background-color="modeActions === 'Edit' ? '#F5F5F5' : ''">
                                    <!-- selected -->
                                    <template v-slot:selection="{ item }">
                                        <div class="d-flex align-center">
                                            <v-icon small class="mr-2" :color="item.icon_color || '#000'">
                                                {{ item.icon }}
                                            </v-icon>

                                            <span>{{ item.status }}</span>
                                        </div>
                                    </template>

                                    <!-- dropdown item -->
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex align-center">
                                            <v-icon small class="mr-2" :color="item.icon_color || '#000'">
                                                {{ item.icon }}
                                            </v-icon>

                                            <span>{{ item.status }}</span>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8 align-center">
                            <v-col cols="12" sm="12" md="12">
                                <h3>Module</h3>
                                <v-autocomplete @change="onChangeModule" v-model="dataItem.module_name"
                                    :items="moduleList" outlined dense :disabled="modeActions === 'Edit'"
                                    :background-color="modeActions === 'Edit' ? '#F5F5F5' : ''" />

                            </v-col>


                        </v-row>
                        <v-row class="mt-n8 align-center">
                            <v-col cols="12" sm="12" md="12">
                                <h3>Sequence </h3>

                                <v-text-field v-model="dataItem.sequence" outlined dense
                                    :disabled="modeActions === 'New'"
                                    :background-color="modeActions === 'New' ? '#F5F5F5' : ''"></v-text-field>
                            </v-col>


                        </v-row>
                        <v-row class="mt-n8 align-center">
                            <v-col cols="12" sm="12" md="12">
                                <h3>Module Status</h3>

                                <v-text-field v-model="dataItem.descriptions" outlined dense></v-text-field>
                            </v-col>


                        </v-row>
                        <v-row class="mt-n8 align-center">
                            <v-col cols="12" sm="12" md="12">
                                <h3>Module Number </h3>

                                <v-text-field v-model="dataItem.module_id" outlined dense
                                    :disabled="modeActions === 'Edit'"
                                    :background-color="modeActions === 'Edit' ? '#F5F5F5' : ''"></v-text-field>
                            </v-col>


                        </v-row>


                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveaddItem()">
                        Save
                    </v-btn>
                    <v-btn depressed outlined width="100" @click="closeaddItem()">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <br />
            </v-card>
        </v-dialog>

        <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

        <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
            :link="link" />
    </v-container>
</template>


<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server } from "@/services/constants";

export default {
    name: "clientTimeLineStatus",
    data(vm) {
        return {
            dialogDelete: false,
            delData: {},
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            id_del: 0,
            search: "",
            leave_type: "",
            dialogDelete: false,
            authorize_view: false,
            authorize_add: false,
            authorize_edit: false,
            authorize_del: false,
            toggleEnable: false,
            selectstatus: "",
            mDataArray: [],
            authorize: [],
            headers: [

                {
                    text: "",
                    value: "actions",
                    align: "center",
                    class: "bg-colorth tabletextwhite",
                    divider: true,
                },
                {
                    text: "Module Name",
                    value: "module_name",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Sequence",
                    value: "sequence",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Timeline Status",
                    value: "status",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },

                {
                    text: "Module Status",
                    value: "descriptions",
                    class: "bg-colorth tabletextwhite",
                    align: "start",
                    divider: true,
                },
                {
                    text: "Module Number",
                    value: "module_id",
                    class: "bg-colorth tabletextwhite",
                    align: "end",
                    divider: true,
                },


            ],
            dialogAddData: false,
            dataItem: {
                timeline_status_id: null,
                module_name: null,
                sequence: null,
                descriptions: null,
                module_id: null,
            },
            modeActions: "",
            timeLineStatusList: [],
            moduleList: ["Trademark Docket", "Patent Docket", "Dispute Resolution", "Corporate", "Immigration"]
        };
    },
    async beforeCreate() {
        console.log("beforeCreate");
        this.$store.state.navMenu = true;
    },
    beforeUpdate() { },
    components: {
        SuccessDialog,
        SuccessDialogPush,
    },
    computed: {
        itemsForSelected() {
            if (this.search.length) {
                return this.dataSource.filter((item) => this.search.includes(item));
            }
            return this.dataSource;
        },
    },
    async mounted() {
        // await api.checkVersion();
        // this.userId = localStorage.getItem(server.USER_ID);
        // let yourUrlString = window.location;

        // let parser = document.createElement("a");
        // parser.href = yourUrlString;

        // this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

        // // alert("authorize_id:" + this.authorize_id);
        // if (this.authorize_id == null || this.authorize_id == 0) {
        //     // this.$router.push("/login");
        //     this.$store.state.global_dialog = true;
        //     this.setupAlertDialog(
        //         true,
        //         "Authorize Failed!!!",
        //         "Please Logout And Login Again!!!",
        //         "text-h5 red--text text-center"
        //     );
        //     this.$router.back();
        // }

        // const router_path = parser.pathname.replace("/", "");

        // const res_auth = await api.getAuthorize(this.userId, router_path);


        // this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
        // this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
        // this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
        // this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;



        // if (!this.authorize_view) {
        //     this.$router.back();
        // }

        // // ----------------- Check Authorize ---------------------------

        // let comp_id = localStorage.getItem(server.COMPANYID);

        // this.userId = localStorage.getItem(server.USER_ID);
        // if (this.userId && api.isLoggedIn()) {
        //     // this.$router.push("/");
        // } else {
        //     this.$store.state.isLogged = false;
        //     this.$router.push("/login");
        // }

        //load data
        try {
            await this.loaddataTimeLineStatus();
            await this.loaddata();
        } catch (err) {
            alert("error")
            console.error(err);
        } finally {
            this.$hideLoader();
        }


    },
    methods: {
        async loaddataTimeLineStatus() {
            const result = await api.getClientTimelineStatus()

            if (result.data && result.data.length > 0) {
                this.timeLineStatusList = result.data
            }
        },
        async loaddata() {
            const result = await api.getClientTimelineStatusCongFigSql()

            if (result.data && result.data.length > 0) {
                this.mDataArray = result.data
            }
            console.log(this.mDataArray)

        },
        opendialogAdd() {
            this.modeActions = "New"
            this.dataItem = {
                timeline_status_id: null,
                module_name: null,
                sequence: null,
                descriptions: null,
                module_id: null,
            };
            this.dialogAddData = true;
        },
        closeaddItem() {
            this.dataItem = {
                timeline_status_id: null,
                module_name: null,
                sequence: null,
                descriptions: null,
                module_id: null,
            };
            this.dialogAddData = false;
        },

        openeditItem(data) {
            this.modeActions = "Edit";

            this.dataItem = { ...data };

            this.dialogAddData = true;
        },

        async saveaddItem() {

            // timeline status
            if (!this.dataItem.timeline_status_id) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please select Status",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // module
            if (!this.dataItem.module_name) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please select Module",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // sequence
            if (
                this.dataItem.sequence === null ||
                this.dataItem.sequence === undefined ||
                this.dataItem.sequence === ""
            ) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Sequence",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // descriptions
            if (
                !this.dataItem.descriptions ||
                !this.dataItem.descriptions.trim()
            ) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Descriptions",
                    "text-h5 red--text text-center"
                );

                return;
            }

            // module id
            if (
                this.dataItem.module_id === null ||
                this.dataItem.module_id === undefined ||
                this.dataItem.module_id === ""
            ) {

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Module Number",
                    "text-h5 red--text text-center"
                );

                return;
            }
            if (this.modeActions == "New") {
                const check_duplications = await api.getClientTimelineStatusCheckDuplications({
                    params: {
                        timeline_status_id: this.dataItem.timeline_status_id,
                        module_name: this.dataItem.module_name
                    }
                })
                if (check_duplications.data && check_duplications.data.length > 0) {
                    this.$store.state.global_dialog = true;

                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "This Module + Status already exists",
                        "text-h5 red--text text-center"
                    );

                    return;
                }

                const check_moduleNumber = await api.getClientTimelineStatusCongFigByModule(this.dataItem.module_name);

                const isDuplicate = check_moduleNumber.data.some(
                    item => Number(item.module_id) === Number(this.dataItem.module_id)
                );


                if (isDuplicate) {
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "Module Number already exists in this module",
                        "text-h5 red--text text-center"
                    );

                    return;
                }
            }
            try {

                this.$showLoader();

                let data = null;

                if (this.modeActions == "New") {


                    const response = await api.createClientTimelineStatusCongFig(this.dataItem);

                    data = response.data;

                } else {


                    const response = await api.updateClientTimelineStatusCongFig(
                        this.dataItem.timeline_status_id,
                        this.dataItem
                    );

                    data = response.data;
                }

                if (data.success) {

                    this.closeaddItem();

                    this.$store.state.global_dialog = true;

                    this.setupAlertDialog(
                        true,
                        "Success",
                        "Saved successfully",
                        "text-h5 green--text text-center"
                    );

                    await this.loaddata();
                }



            } catch (err) {

                console.error(err);

                this.$store.state.global_dialog = true;

                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Cannot save data",
                    "text-h5 red--text text-center"
                );

            } finally {

                this.$hideLoader();

            }
        },
        async onChangeModule(value) {
            this.$showLoader()
            const result = await api.getClientTimelineStatusCongFigByModule(value)

            if (result.status == 200) {
                if (result.data.length > 0) {
                    this.dataItem.sequence = Number(result.data.length + 1)
                    const maxModuleId = Math.max(
                        ...result.data.map(item => Number(item.module_id || 0))
                    );
                    this.dataItem.module_id = maxModuleId + 1
                } else {
                    this.dataItem.sequence = 1
                    this.dataItem.module_id = 1
                }
            } else {
                this.dataItem.sequence = null;
            }
            this.$hideLoader()
        },
        opendeleteItem(data) {
            this.dialogDelete = true;
            this.delData = {
                module_name: data.module_name,
                timeline_status_id: data.timeline_status_id,
            }
        },
        closeDelete() {
            this.dialogDelete = false;
        },
        async deleteItemConfirm() {
            // 1. validate ก่อน
            if (!this.delData?.module_name || !this.delData?.timeline_status_id) {
                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please select Module and Status",
                    "text-h5 red--text text-center"
                )
                return
            }

            try {
                this.$showLoader()

                // 2. call API
                const result = await api.deleteClientTimelineStatusCongFig({
                    module_name: this.delData.module_name,
                    timeline_status_id: this.delData.timeline_status_id
                })

                // 3. success check
                if (result?.data?.success) {
                    this.setupAlertDialog(
                        true,
                        "Success",
                        "Deleted successfully",
                        "text-h5 green--text text-center"
                    )

                    await this.loaddata() // reload table
                } else {
                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "Delete not success",
                        "text-h5 red--text text-center"
                    )
                }

            } catch (err) {
                console.error(err)

                // 4. error case
                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Server error / Cannot delete data",
                    "text-h5 red--text text-center"
                )

            } finally {
                this.dialogDelete = false;
                this.$hideLoader()
            }
        },
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },

    },
};
</script>

<style scoped>
.bg-colorth {
    background-color: #595959;
    color: red;
}

.text-left {
    color: aliceblue;
}

.widthsizesearch {
    width: 70%;
}

.theme--light.v-card {
    border-color: white;
}

.disabled-field .v-input__slot {
    background-color: #F5F5F5 !important;
}
</style>